import { IEventsState } from "./eventsState";

export default {
  SET_SELECTED_EVENTS( state: IEventsState, val: Array<string> ) : void {
    state.selectedCalendars = val;
  },
};